import { isTourCurrentlyActive } from 'onboarding-tours/util/activeTour';
import { getOnboardingGuide } from 'onboarding-tours/util/banner';
import { getShouldEnableTour } from 'onboarding-tours/util/tourStorage';
const GROWTH_IN_APP_SIDE_PANEL_KEY = 'Growth:InAppSidePanel:ShowSidepanel';
const MESSAGE_KEYS_ACTIONS = {
  ONBOARDING_TOURS: ['tourCompleted', 'close'],
  IN_APP_ONBOARDING_PANEL: ['closed']
};
const hasGrowthInAppSidePanel = () => {
  return sessionStorage.getItem(GROWTH_IN_APP_SIDE_PANEL_KEY);
};
export const subscribeToOnboardingComponentCompletion = callback => {
  const handler = event => {
    if (!event.data) {
      return;
    }
    const {
      key,
      action
    } = event.data;
    if (MESSAGE_KEYS_ACTIONS[key] && MESSAGE_KEYS_ACTIONS[key].includes(action)) {
      callback();
    }
  };
  window.addEventListener('message', handler, false);
  return () => {
    window.removeEventListener('message', handler, false);
  };
};
export const getHasActiveOnboardingComponent = () => {
  return isTourCurrentlyActive() || getOnboardingGuide() || getShouldEnableTour() || hasGrowthInAppSidePanel();
};